var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2924 12.7261C16.326 16.3512 19.4726 17.5576 19.5074 17.573C19.4807 17.658 19.0046 19.292 17.8497 20.9799C16.8513 22.4392 15.815 23.893 14.1827 23.9231C12.5789 23.9527 12.063 22.972 10.2293 22.972C8.39607 22.972 7.82304 23.893 6.30472 23.9527C4.7291 24.0123 3.52925 22.3748 2.52262 20.9208C0.465479 17.9469 -1.10656 12.517 1.0043 8.85181C2.05291 7.03162 3.92696 5.87909 5.96095 5.84952C7.50815 5.82004 8.96856 6.89044 9.91439 6.89044C10.8596 6.89044 12.6343 5.6032 14.5 5.79223C15.2809 5.82476 17.4734 6.10766 18.8812 8.16831C18.7677 8.23863 16.2652 9.69547 16.2924 12.7262M13.2781 3.82469C14.1146 2.81211 14.6776 1.40259 14.524 0C13.3182 0.0484571 11.8602 0.803505 10.9953 1.81547C10.2202 2.7117 9.54144 4.14606 9.7246 5.52084C11.0686 5.62484 12.4415 4.83787 13.2781 3.82469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e6e3256d7559fe592d9278d71719c004.svg";
export { ForwardRef as ReactComponent };